// extracted by mini-css-extract-plugin
export default {"Container":"HeroSection_Container__WWR6b","MainNews":"HeroSection_MainNews__1kEl5"};